export { default as ReporteInventarios } from "./ReporteInventarios";
